import { render, staticRenderFns } from "./Errormessage.vue?vue&type=template&id=6e387770"
import script from "./Errormessage.vue?vue&type=script&lang=js"
export * from "./Errormessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports